import React from 'react';
import classNames from 'classnames';

import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { FloorPlanActions } from 'Src/feature/floor-plan/FloorPlanActions';
import { FloorPlanViewer, TableProps } from 'Src/feature/floor-plan/FloorPlanViewer';
import { useFloorPlanPage } from 'Src/feature/floor-plan/useFloorPlanPage';
import { FloorPlanViewerProvider } from 'Src/feature/floor-plan/useFloorPlanViewerStore';
import { RevenueCenter } from 'Src/feature/revenue-center/revenueCenterService';

import styles from './ChecksFloorPlan.module.scss';

const ChecksFloorPlan: React.FC = () => {
  const store = useFloorPlanPage();

  // TODO: Initial load view/ux
  if (store.isLoading) return <></>;

  if (store.errors.length) {
    const hasTimeoutErrors = store.errors.find((e) => e.isTimeout);

    // timeout errors should be handled via another mechanism, they will go through the retryFn
    // for react query and be displayed through an alert
    if (hasTimeoutErrors) return <></>;

    return (
      <Flex gap="xs" alignItems="center" justifyContent="center" fullWidth fullHeight>
        {
          store.errors.map((error) => (
            <React.Fragment key={`${error.title}-${error.message}`}>
              <Copy variant="h3" value={error.title} />
              <Copy component="p" value={error.message} />
            </React.Fragment>
          ))
        }
      </Flex>
    );
  }

  return (
    <div className={classNames(styles.grid, styles.viewer, styles.noEdit)}>
      <FloorPlanViewerProvider {...store.providerProps}>
        <FloorPlanViewer
          floorplanId={store.selected.floorPlan?.id ?? -1}
          tableProps={(store.selected.floorPlan?.layout ?? []) as TableProps[]}
          initialWidth={window.innerWidth - 100}
          initialHeight={window.innerHeight - 100}
          selectedRevenueCenter={store.selected.revenueCenter as RevenueCenter}
        />
        <FloorPlanActions />
      </FloorPlanViewerProvider>
    </div>
  );
};

export { ChecksFloorPlan };
